import theme from '@/style';
import LazyImage from '@/components/basic/image';
import React from 'react';
import {useTranslation} from 'react-i18next';
import ShareButton from './share-btn';
import {toPriceStr} from '@/utils';
import {DrawStatus, DATA_MAP} from '../draw-staus';
import WonResult from '../won/won';
const copyIcon = require('@components/assets/icons/bets/copy.webp');

export interface BetsCardType {
  status: 0 | 1 | 2 | 3 | 4;
  cover: string | number;
  tag?: string;
  tagTwo?: string;
  title?: string;
  id?: string;
  betTime?: string;
  drawTime?: string;
  hasShare?: boolean;
  hasAward?: boolean;
  rightEle?: React.ReactElement | null;
  payment?: number;
  reward?: number;
  canGoDetail?: boolean;
  content?: React.ReactElement | string;
  result?: React.ReactElement | null;
  onShare?: () => void;
  onCopy?: () => void;
  goDetail?: () => void;
  awardAmount?: number;
  style?: React.CSSProperties;
  statusTip?: string;
  hasResult?: boolean;
}

const BetsCard = (props: BetsCardType) => {
  const {
    status,
    id = '',
    onCopy,
    cover,
    title,
    tag,
    tagTwo,
    payment = 0,
    betTime,
    drawTime,
    reward = 0,
    canGoDetail = true,
    hasShare = false,
    onShare,
    style = {},
    hasAward = false,
    goDetail = () => {},
    result,
    statusTip,
    hasResult = true,
  } = props;
  const {i18n} = useTranslation();
  const Wrap = canGoDetail ? 'button' : 'div';
  return (
    <Wrap
      onClick={canGoDetail ? goDetail : undefined}
      className="mt-3 block w-full border-0 bg-transparent p-0 text-left"
      style={style}>
      <div
        className="rounded-t-xl pb-6"
        style={{backgroundColor: theme.backgroundColor.betsBgDark}}>
        <div className="flex items-center p-3">
          <div className="h-12 w-12 overflow-hidden rounded-lg">
            <LazyImage
              imageUrl={cover}
              width={48}
              height={48}
              occupancy="transparent"
            />
          </div>
          <div className="ml-3 flex flex-1 items-center justify-between">
            <div className="flex-1">
              <div className="mb-1 truncate text-sm font-bold text-white">
                {title}
              </div>
              <div className="mt-0.5 flex flex-col gap-0.5">
                <span className="text-xs font-medium text-white">
                  Draw time
                </span>
                <span className="text-xs font-bold text-white">{drawTime}</span>
              </div>
            </div>
            <div>
              {!!tag && (
                <div className="rounded-[1.25rem] bg-white/30 px-3 py-1">
                  <span className="font-bold text-white">{tag}</span>
                </div>
              )}
              {!!tagTwo && (
                <div className="mt-1 rounded-[1.25rem] bg-white/30 px-3 py-1">
                  <span className="font-bold text-white">{tagTwo}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="-mt-3 overflow-hidden rounded-t-2xl bg-white pb-3 pt-3">
        <div className="flex justify-between px-3">
          <div className="flex-1">
            <div className="flex items-center gap-1">
              <span className="font-medium text-[#9FA5AC]">
                {i18n.t('label.order')} {i18n.t('label.id')}
              </span>
              <span className="font-medium">{id}</span>
              <button
                type="button"
                className="border-0 bg-transparent p-0"
                onClick={event => {
                  event.stopPropagation();
                  onCopy?.();
                }}>
                <LazyImage
                  imageUrl={copyIcon}
                  width={14}
                  height={14}
                  occupancy="transparent"
                />
              </button>
            </div>
            <div className="mt-1 flex items-center gap-1">
              <span className="font-medium text-[#9FA5AC]">
                {i18n.t('bets-page.label.bettingTime')}
              </span>
              <span className="font-medium">{betTime}</span>
            </div>
          </div>
          <div className="flex flex-col items-end">
            <span className="font-medium text-[#9FA5AC]">
              {i18n.t('label.payment')}
            </span>
            <span
              className="text-base font-bold"
              style={{color: theme.basicColor.dark}}>
              {toPriceStr(payment, {fixed: 2})}
            </span>
          </div>
        </div>
        <div className="my-2 flex items-center justify-between">
          <div
            className="-ml-1 h-3 w-3 rounded-full"
            style={{backgroundColor: theme.backgroundColor.lightGrey}}
          />
          <div className="h-px flex-1 border-t-2 border-dashed border-[#9FA5AC]" />
          <div
            className="-mr-1 h-3 w-3 rounded-full"
            style={{backgroundColor: theme.backgroundColor.lightGrey}}
          />
        </div>
        <div className="flex min-h-7 items-center justify-between px-3">
          <span className="text-sm font-bold">
            {i18n.t('game-page.label.myNum')}
          </span>
          {hasShare && <ShareButton onShare={onShare} hasAward={hasAward} />}
        </div>
        <div className="mb-2 px-3 pt-1">
          <DrawStatus
            colors={DATA_MAP[status].bg}
            textColor={DATA_MAP[status].color}
            label={i18n.t(`bets-page.status.${DATA_MAP[status].text}`)}
            id={id}
            tip={statusTip}
            onCopy={onCopy}
          />
          {result}
          {hasResult && (
            <>
              {(status === 1 || status === 4) && reward > 0 && (
                <WonResult
                  style={[theme.padding.topxxl, theme.margin.btms]}
                  awardAmount={reward}
                />
              )}
              {(status === 0 || (status === 4 && reward === 0)) && (
                <div className="pb-4 pt-6 text-center text-[0.9375rem] text-primary">
                  <span>{i18n.t('game-page.label.guessWrong')}</span>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </Wrap>
  );
};

export default BetsCard;
